// extracted by mini-css-extract-plugin
module.exports = {"loader":"folder_drop_loading-module__loader--3Ndvr"};